export enum Granularity {
    Daily = 'Daily',
    Weekly = 'Weekly',
    Monthly = 'Monthly',
}
